// bootstrap-vue refocuses a dropdown's toggle when it closes, and Chrome rings that focus as
// :focus-visible even when the menu was used with the mouse. Drop it unless the keyboard drove it.
export function blurToggleAfterPointerClose(dropdown) {
  const el = dropdown.$el;
  let pointer = false;
  // capture phase: bootstrap-vue stops propagation of the keys it handles (Enter, Esc, arrows)
  el.addEventListener('pointerdown', () => { pointer = true; }, true);
  el.addEventListener('keydown', () => { pointer = false; }, true);
  dropdown.$on('hidden', () => {
    if (!pointer) return;
    // a macrotask, so it lands after bootstrap-vue's $nextTick refocus
    setTimeout(() => {
      if (el.contains(document.activeElement)) document.activeElement.blur();
    });
  });
}
